<template>
  <div>
    <div class="dialog-table-panel background">
      <!-- Selection of Client via ComboBox with Label -->
      <div class="form-group nopadding">
        <div class="input-group group">
          <label class="comboBoxLabel">{{ lang.S0111 }}:</label>
          <select
            class="form-control nopadding comboBoxGroup"
            v-model="actualClient"
            @change="loadPolicies()"
          >
            <option disabled value="-1">{{ lang.S0112 }}</option>
            <option
              v-for="client in clients"
              :key="client.ClientId"
              :value="client.ClientId"
            >
              {{ client.ClientName }}
            </option>
          </select>
        </div>
      </div>

      <!-- List of CustomPropertyValues for selected Client -->
      <div class="dialog-table-panel" v-if="actualClient && actualClient != -1">
        <table
          class="table table-striped table-hover main-table"
          style="overflow-y: unset"
        >
          <thead>
            <tr>
              <th class="text-center w30">
                <a class="table-header" role="button">{{ lang.S0115 }}</a>
              </th>
              <th class="text-center w70">
                <a class="table-header" role="button">{{ lang.S0172 }}</a>
              </th>
            </tr>
          </thead>
          <tbody class="main-table-scrollbar client-policies-table">
            <template v-if="surveys">
              <tr v-for="(property, index) in surveys" :key="index">
                <td class="td-cb-policies w30 moreheadroom">
                  <a
                    class="table-header"
                    role="button"
                    @click="togglePermitted(property)"
                    >{{ property.surveyTitle }}</a
                  >
                </td>
                <td class="w70" style="text-align: left">
                  <div class="reset-this">
                    <treeselect
                      :placeholder="lang.S0041"
                      v-model="property.SelectedItems"
                      :options="property.surveysQuestions"
                      :auto-load-root-options="false"
                      :multiple="true"
                      :limit="5"
                      :searchable="true"
                      :showCount="true"
                      :flat="true"
                      valueFormat="id"
                      showCountOf="LEAF_DESCENDANTS"
                      :disabled="true"
                    />
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.min.css";
import policiesMixin from "../../mixins/policiesmixin";
import "../../styles/usermanagement.css";

export default {
  name: "SurveysQuestionsPoliciesControl",
  data() {
    return {
      surveys: [],
      actualClient: -1,
    };
  },
  mixins: [policiesMixin],
  props: {
    user: Object,
    lang: Object,
    clients: Array,
  },
  methods: {
    togglePermitted(item) {
      if (!item.surveysQuestions) return;
      if (item.SelectedItems.length === item.surveysQuestions.length) {
        item.SelectedItems = [];
        return;
      } else {
        item.surveysQuestions.forEach((element) => {
          item.SelectedItems.push(element.waveId);
        });
      }
    },
    getPropertySubItems: function (property) {
      if (!property.surveysQuestions) return [];
      return property.surveysQuestions;
    },
    getSelectedSubItems(items) {
      let result = [];
      if (!(items.length > 0)) return result;
      items.forEach((element) => {
        result = result.concat(element.SelectedItems);
      });
      return result;
    },
    saveChanges() {
      let itms = this.getSelectedSubItems(this.surveys);
      this.putItems(
        this,
        this.getServiceUrl(this),
        itms,
        "SurveysQuestionsPolicies"
      );
    },
    getServiceUrl(_this) {
      return (
        "api/SurveysQuestionsPolicies/" +
        _this.user.UserId +
        "/" +
        _this.actualClient
      );
    },
    getUnifiedId(_data) {
      _.forEach(_data, (item) => {
        var selected = [];
        _.forEach(item.surveysQuestions, (val) => {
          if (val.P === true) selected.push(val.id);
        });
        item.SelectedItems = selected;
      });
      return _data;
    },
    loadPolicies() {
      if (!this.actualClient || this.actualClient == -1) return;
      let _this = this;
      _this.surveys = [];

      $.ajax({
        method: "GET",
        url: _this.getServiceUrl(_this),
        success: (data) => {
          _this.surveys = _this.getUnifiedId(data);
        },
        error: () => {
          console.error(
            "Data access failed in SurveysQuestionsPoliciesControl.loadPolicies()"
          );
        },
        complete: () => {
          _this.$root.$emit("measureScreenRequested", "");
        },
      });
    },
  },
};
</script>

<style scoped>
tbody {
  min-height: 200px;
  overflow: auto;
}

.moreheadroom {
  padding-top: 16px;
}
</style>



// WEBPACK FOOTER //
// SurveysQuestionsPoliciesControl.vue?392f6866